import { is } from 'ramda';
import { message } from 'antd';
import Papa from 'papaparse';
export var cautionTextItems = {
    ticket_member: [
        'The file should be in .csv format',
        'The file should contain column with member IDs. This column should be called "member_id" and the value should be a number',
        "The file shouldn't contain any duplicates",
        'The file can also contain a "notes" column. Its value will be added as the initial Notebook Entry in the ticket.',
        "Once you upload the file, you'll be able to check for errors to polish the document"
    ],
    benefit_organizations: [
        'The file should be in .csv format',
        'The file should contain only column with organizations namings. This column should be called "organization_name" and the value should be a string',
        'The number of organizations should not exceed 1000',
        "The file shouldn't contain any duplicates",
        "Once you upload the file, you'll be able to check for errors to polish the document"
    ]
};
export var ERRORS = {
    ticket_member: [
        'Error finding "member_id" matches in the document',
        'Some rows are missing value for member_id column (or value is invalid)',
        'Some rows have same member_id value'
    ],
    benefit_organizations: [
        'Error finding "organization_name" matches in the document',
        'Provided file consist of more than one column',
        'Some rows are missing value for organization_name column (or value is invalid)',
        'Some rows have same organization_name value',
        'The file size exceeds the allowed limit of 1000 Organizations names'
    ]
};
export var validateTicketMemberFile = function (data) {
    // grabbing member_id column data and store it in IDs array
    var specificTicketAttributes = data === null || data === void 0 ? void 0 : data.map(function (_a) {
        var member_id = _a.member_id, notes = _a.notes;
        return ({
            member_id: member_id,
            notes: notes || null
        });
    });
    // check whether IDs is empty
    var noMatches = !specificTicketAttributes.some(function (_a) {
        var member_id = _a.member_id;
        return member_id;
    });
    if (noMatches) {
        message.error(ERRORS.ticket_member[0]);
        return [];
    }
    // check whether any rows are missing member_id value
    var hasInvalidValues = specificTicketAttributes.some(function (_a) {
        var member_id = _a.member_id;
        return !(is(Number, member_id) || is(String, member_id));
    });
    if (hasInvalidValues) {
        message.error(ERRORS.ticket_member[1]);
        return [];
    }
    // look for duplicates
    var uniqueIDs = new Set();
    specificTicketAttributes.forEach(function (_a) {
        var member_id = _a.member_id;
        return uniqueIDs.add(member_id);
    });
    var hasDuplicates = uniqueIDs.size !== specificTicketAttributes.length;
    if (hasDuplicates) {
        message.error(ERRORS.ticket_member[2]);
        return [];
    }
    // if everything is more or less OK we let HG to upload the list of IDs to proceed with BE validation
    return specificTicketAttributes;
};
export var validateOrganizationFile = function (data) {
    // grabbing organization_name column data and store it in IDs array
    var organizationsData = data === null || data === void 0 ? void 0 : data.map(function (_a) {
        var organization_name = _a.organization_name;
        return ({
            organization_name: organization_name
        });
    });
    // check whether IDs is empty
    var noMatches = !organizationsData.some(function (_a) {
        var organization_name = _a.organization_name;
        return organization_name;
    });
    if (noMatches) {
        message.error(ERRORS.benefit_organizations[0]);
        return [];
    }
    // check if more than 2 columns provided
    var isMoreThanOneCloumn = Object.keys(data[0]).length > 1;
    if (isMoreThanOneCloumn) {
        message.error(ERRORS.benefit_organizations[1]);
        return [];
    }
    // check whether any rows are missing organization_name value
    var hasInvalidValues = organizationsData.some(function (_a) {
        var organization_name = _a.organization_name;
        return !is(String, organization_name);
    });
    if (hasInvalidValues) {
        message.error(ERRORS.benefit_organizations[2]);
        return [];
    }
    // look for duplicates
    var uniqueOrganizations = new Set();
    organizationsData.forEach(function (_a) {
        var organization_name = _a.organization_name;
        return uniqueOrganizations.add(organization_name);
    });
    var hasDuplicates = uniqueOrganizations.size !== organizationsData.length;
    if (hasDuplicates) {
        message.error(ERRORS.benefit_organizations[3]);
        return [];
    }
    var hasProperLength = organizationsData.length <= 1000;
    if (!hasProperLength) {
        message.error(ERRORS.benefit_organizations[4]);
        return [];
    }
    // if everything is more or less OK we let HG to upload the list of organizations to proceed with BE validation
    return organizationsData.map(function (i) { var _a; return (_a = i.organization_name) === null || _a === void 0 ? void 0 : _a.trim(); });
};
var VALIDATION_BY_TYPE = {
    ticket_member: validateTicketMemberFile,
    benefit_organizations: validateOrganizationFile
};
export var FILE_ADDED_TEXT = {
    ticket_member: function (length) {
        return "Tickets for ".concat(length, " members are going to be created. You can also");
    },
    benefit_organizations: function (length) {
        return "".concat(length, " organizations are going to be added. You can also");
    }
};
export var getPapaparseConfig = function (file, uid, type, cb) {
    if (file) {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: function (_a) {
                var _b;
                var data = _a.data;
                if (!uid || uid !== file.uid) {
                    var attributes = (_b = VALIDATION_BY_TYPE === null || VALIDATION_BY_TYPE === void 0 ? void 0 : VALIDATION_BY_TYPE[type]) === null || _b === void 0 ? void 0 : _b.call(VALIDATION_BY_TYPE, data);
                    if (attributes) {
                        cb(attributes, file.uid);
                    }
                }
            }
        });
    }
    else {
        message.error('Failed to load the file');
    }
};
